import React, { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';

const Popup = ({vendorColor, text}) => {
  const [isOpen, setIsOpen] = useState(true);
  const popupRef = useRef(null);

  // Function to process text and convert newlines and bullet points
  const formatText = (text) => {
    if (!text) return [];
    
    // Split text into paragraphs by double newlines
    return text.split('\n').map((paragraph, index) => {
      // Check if the line starts with "• " or "* " for bullet points
      if (paragraph.trim().startsWith('• ') || paragraph.trim().startsWith('* ')) {
        return (
          <li key={index} className="ml-4 mb-2 list-disc">
            {paragraph.trim().replace(/^[•*]\s/, '')}
          </li>
        );
      }
      // Regular paragraph
      return paragraph.trim() ? (
        <p key={index} className="mb-3">
          {paragraph}
        </p>
      ) : null;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  const onIgnoreClick = (e) => {
    e.stopPropagation(); // Prevent the click from affecting the sofa
  };


  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black/40 z-[1500]"
      onClick={onIgnoreClick}>
      <div 
        ref={popupRef}
        className="relative bg-gray-50 rounded-xl p-6 shadow-lg max-w-sm w-full mx-4 animate-in fade-in duration-200"
        onClick={onIgnoreClick}>

        <button 
          onClick={handleClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X size={20} />
        </button>
        
        <div className="mt-2"
          onClick={onIgnoreClick}>
          <div className="text-gray-600 mb-6 whitespace-pre-line"
               onClick={onIgnoreClick}>
            {text.includes('• ') || text.includes('* ') ? (
              <ul className="list-disc pl-5">
                {formatText(text)}
              </ul>
            ) : (
              formatText(text)
            )}
          </div>
          <div className="flex justify-end"
               onClick={onIgnoreClick}>
            <button
              onClick={handleClose}
              className="w-full h-12 px-4 rounded-lg flex items-center justify-center gap-2 transition-all hover:shadow-lg text-white"
              style={{ backgroundColor: vendorColor }}
            >
              Go!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;